import * as React from "react";
import { Link } from "react-router-dom";
import Headline from "../../components/Headline";
import { MainLayout } from "../../components/Layout";
import LinkButton from "../../components/LinkButton";
import { URL_PATHS } from "../../routes";
import "./styles.scss";
import {
    IAPPaymentMethod,
    OtherPaymentMethod,
    PaymentMethod
} from "../../generated/lib-domain/iap";
import { PaymentType } from "../../generated/lib-domain/paymentZeus";
import { PlanPrice } from "../../components/PlanPrice";
import PriceDifference from "../../components/Messages/PriceDifference";
import * as aa from "../../generated/UserAPIAgent";
import FreeMemberPaymentInfo from "./FreeMemberPaymentInfo";
import {
    CardPaymentPlan,
    PaymentPlanEnum,
    PaymentPlanType,
    SubscriptionEnum
} from "../../generated/UserAPIAgent";
import {
    PAYMENT_PLANS,
    PaymentPlan
} from "../../generated/lib-domain/paymentPlan";

interface PaymentInfoPageProps {
    myUser: aa.User;
    paymentMethod: PaymentMethod;
    cardNo?: string;
    nextUpdate: string;
    paidFinishDate: string;
    isChangedPaymentMethod: boolean;
    paymentType: PaymentType;
    onNavigateToPaymentMake: (newPaymentPlanId: PaymentPlanEnum) => void;
    currentPaymentPlan: PaymentPlanType | null;
    cardPaymentPlans: CardPaymentPlan[];
    onChangeCreditCardInfo: () => void;
}

const PaymentInfo = (props: PaymentInfoPageProps): JSX.Element => {
    const switchInfo = () => {
        if (props.isChangedPaymentMethod) {
            return changedCreditCardPaymentInfo();
        }

        switch (props.paymentMethod) {
            case IAPPaymentMethod.IOS_IAP:
                return inAppPurchasePaymentInfo();
            case OtherPaymentMethod.CREDIT_CARD:
                if (props.isChangedPaymentMethod) {
                    return changedCreditCardPaymentInfo();
                }

                if (props.paidFinishDate !== null) {
                    return hadCanceledCreditCard();
                }
                return creditCardPaymentInfo();
        }
    };
    const creditCardPaymentInfo = (): JSX.Element => {
        return (
            <section className="payment-info">
                <dl>
                    <div className="row">
                        <dt>次回更新</dt>
                        <dd>{props.nextUpdate}</dd>
                    </div>
                </dl>
            </section>
        );
    };
    const changedCreditCardPaymentInfo = () => {
        // NOTE IAP決済からカード決済に移行したユーザー
        return (
            <>
                <section className="payment-info">
                    <dl>
                        <div className="row">
                            <dt>
                                クレジットカード決済
                                <br />
                                開始予定日
                            </dt>
                            <dd>{props.nextUpdate}</dd>
                        </div>
                    </dl>
                </section>
                <section className="to-payment-make">
                    <div className="to-apple-subscription-stop-strong">
                        お済みですか？
                    </div>
                    <div className="to-apple-subscription-stop">
                        ご自身で
                        <Link to={URL_PATHS.cancelSubscriptionProcedure()}>
                            サブスクリプションの解約
                        </Link>
                        を行って
                        <br />
                        いただく必要がございます。
                    </div>
                </section>
            </>
        );
    };
    const inAppPurchasePaymentInfo = (): JSX.Element => {
        return (
            <>
                <section className="payment-info">
                    <dl>
                        <div className="row">
                            <dt>有料会員</dt>
                            <dd>
                                {props.currentPaymentPlan &&
                                    PAYMENT_PLANS.find(
                                        (plan) =>
                                            plan.id ===
                                            props.currentPaymentPlan.id
                                    ).title}
                            </dd>
                        </div>
                        <div className="row">
                            <dt>次回更新</dt>
                            <dd>{props.nextUpdate}</dd>
                        </div>
                        <div className="row">
                            <dt>決済履歴</dt>
                            <dd>AppleID 購入履歴から確認できます</dd>
                        </div>
                    </dl>
                </section>
                <section className="to-payment-make">
                    {props.currentPaymentPlan?.id ===
                        PaymentPlanEnum.LITE_1M_IOS_IAP_1000 && (
                        <div className="payment-make-lead-message">
                            {
                                PAYMENT_PLANS.find(
                                    (plan) =>
                                        plan.id ===
                                        PaymentPlan.Standard1MCard9800
                                ).title
                            }
                            に登録して
                            <br />
                            クレジットカード決済に変更する
                        </div>
                    )}
                    {
                        <PriceDifference
                            subscription={SubscriptionEnum.STANDARD}
                            addText={true}
                            isNotPaidMember={props.currentPaymentPlan === null}
                        />
                    }
                    <LinkButton
                        to="#"
                        onClick={() => {
                            props.onNavigateToPaymentMake(
                                PaymentPlanEnum.STANDARD_1M_CARD_9800
                            );
                        }}
                        lines={2}
                        color="primary"
                    >
                        <PlanPrice
                            cardPaymentPlan={props.cardPaymentPlans.find(
                                (plan) =>
                                    plan.paymentPlanId ===
                                    PaymentPlanEnum.STANDARD_1M_CARD_9800
                            )}
                        />
                        <br />
                        {props.currentPaymentPlan.id ===
                        PaymentPlanEnum.LITE_1M_IOS_IAP_1000
                            ? PAYMENT_PLANS.find(
                                  (plan) =>
                                      plan.id ===
                                      PaymentPlanEnum.STANDARD_1M_CARD_9800
                              ).title
                            : "クレジットカード決済"}
                        に変更する
                    </LinkButton>
                    <div className="to-apple-subscription-stop">
                        ご自身で
                        <Link to={URL_PATHS.cancelSubscriptionProcedure()}>
                            サブスクリプションの解約
                        </Link>
                        を行って
                        <br />
                        いただく必要がございます。
                    </div>
                    {props.currentPaymentPlan.id ===
                        PaymentPlanEnum.STANDARD_1M_IOS_IAP_12000 && (
                        <div className="answer small-font-size">
                            ※
                            サブスクリプションが終了した翌日より自動で適用されます。二重に課金されることはございません。
                            <Link to={URL_PATHS.paymentSystemChangeInfo()}>
                                詳しく見る &gt;
                            </Link>
                        </div>
                    )}
                    {props.currentPaymentPlan.id ===
                        PaymentPlanEnum.LITE_1M_IOS_IAP_1000 && (
                        <div className="answer">
                            <Link
                                to="#"
                                onClick={() => {
                                    props.onNavigateToPaymentMake(
                                        PaymentPlanEnum.LITE_1M_CARD_1000
                                    );
                                }}
                            >
                                ライトプランのまま
                                <br />
                                クレジットカード決済に変更する &gt;
                            </Link>
                        </div>
                    )}
                    <div className="answer">
                        <Link to={URL_PATHS.cancelSubscriptionProcedure()}>
                            有料会員プランを停止する &gt;
                        </Link>
                    </div>
                </section>
            </>
        );
    };

    const hadCanceledCreditCard = () => {
        return (
            <section className="payment-info">
                <dl>
                    <div className="row">
                        <dt>
                            有料会員プラン
                            <br />
                            の停止予定日
                        </dt>
                        <dd className="stop-date">{props.paidFinishDate}</dd>
                    </div>
                </dl>
                <p className="had-cancel-cation">
                    ※表示されている日付以降、お相手
                    <br />
                    とのやりとりができなくなります。
                </p>
                <div className="restart-link-wrapper">
                    <LinkButton
                        to={URL_PATHS.paymentRestartConfirm()}
                        lines={2}
                        color="primary"
                    >
                        有料会員プランの
                        <br />
                        継続設定を変更
                    </LinkButton>
                </div>
                <div className="cancel-description">
                    {/*TODO webに退会機能が実装されたら文言修正する*/}
                    有料会員プランを停止してもアカウントは削除されません。
                    <br />
                    <Link to={URL_PATHS.contractPaidMember()}>
                        退会申請は契約確認・変更から行えます。
                    </Link>
                </div>
            </section>
        );
    };

    const stopLink = () => {
        if (props.isChangedPaymentMethod) {
            return (
                <section className="stop-payment">
                    <Link to={URL_PATHS.transitionCancel()}>
                        クレジットカード決済への移行をキャンセル &gt;
                    </Link>
                </section>
            );
        }

        if (props.paymentMethod === OtherPaymentMethod.CREDIT_CARD) {
            if (props.paidFinishDate !== null) {
                return;
            }

            return (
                <section className="stop-payment">
                    <Link to={URL_PATHS.paymentCancel()}>
                        有料会員プランを停止する &gt;
                    </Link>
                </section>
            );
        }
    };

    const paymentMethod = (): string => {
        if (props.isChangedPaymentMethod) {
            return "クレジットカード";
        }

        switch (props.paymentMethod) {
            case "ios_iap":
                return "Apple サブスクリプション";
            default:
                return "クレジットカード";
        }
    };

    if (!props.myUser.isPaid) {
        // 無料会員
        return <FreeMemberPaymentInfo />;
    }
    return (
        <MainLayout>
            <Headline>決済情報</Headline>
            <section className="confirm-payment">
                <div className="current-payment-method">
                    登録済みの決済方法 : {paymentMethod()}
                </div>
                {/*クレジットカード決済orIAPからクレジットカード決済に移行中ユーザーのみ表示*/}
                {(props.paymentMethod === OtherPaymentMethod.CREDIT_CARD ||
                    props.isChangedPaymentMethod) && (
                    <div className="card-number">
                        <span>**** **** **** {props.cardNo}</span>
                        {!props.isChangedPaymentMethod &&
                            (props.paidFinishDate !== null ? (
                                <span className="payment-stopping">停止中</span>
                            ) : (
                                // NOTE: クレジットカード番号の変更
                                <a
                                    href="#"
                                    onClick={props.onChangeCreditCardInfo}
                                >
                                    変更する
                                </a>
                            ))}
                    </div>
                )}
                {props.isChangedPaymentMethod && (
                    <p className="card-change-description">
                        変更をご希望の場合は１度クレジットカード決済への移行をキャンセルして再度ご登録をお願い致します。
                    </p>
                )}
            </section>
            {switchInfo()}
            {stopLink()}
        </MainLayout>
    );
};

export default PaymentInfo;
